import { Thead, Tr, Th, Flex, HStack, Text, Icon } from '@chakra-ui/react';
import { ArrowUp, ArrowDown, Rows3 } from 'lucide-react';
import { t } from '@lingui/core/macro';
import { SortOrder } from '@duke-hq/lib/pagination';
import type { NatRuleColumn } from '@duke-hq/avetmiss/NATTypes';
import { pxToRem } from '@duke-hq/ui/constants/scalable';
import {
  getNatColumnContentWidth,
  getNatColumnWidth,
  NAT_CELL_PADDING_X,
  NAT_CELL_PADDING_Y,
} from './natTableLayout';

type NATTableHeaderProps = {
  columns: Record<string, NatRuleColumn>;
  sortConfig: { key: string; direction: SortOrder } | null;
  onSort: (key: string) => void;
};

export function NATTableHeader({ sortConfig, onSort, columns }: NATTableHeaderProps) {
  return (
    <Thead position="sticky" top={0} bg="bg.surface" zIndex={10} w="full">
      <Tr style={{ display: 'flex', width: '100%' }} borderLeft="4px solid transparent">
        <Th
          w={pxToRem(40)}
          minW={pxToRem(40)}
          maxW={pxToRem(40)}
          p={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon as={Rows3} boxSize={pxToRem(18)} color="gray.600" />
        </Th>
        {Object.entries(columns).map(([key, column], index) => {
          const width = getNatColumnWidth(column, index, Object.keys(columns).length);
          const minW = getNatColumnContentWidth(column);
          return (
            <Th
              key={key}
              onClick={() => {
                onSort(key);
              }}
              cursor="pointer"
              _hover={{ bg: 'gray.100' }}
              width={width}
              maxW={width}
              minW={minW}
              display="flex"
              px={NAT_CELL_PADDING_X}
              py={NAT_CELL_PADDING_Y}
            >
              <Flex align="center" justify="space-between">
                <HStack spacing="5">
                  <Text>{column.name}</Text>
                  {sortConfig?.key === key && (
                    <Icon
                      as={sortConfig.direction === SortOrder.ASC ? ArrowUp : ArrowDown}
                      aria-label={
                        sortConfig.direction === SortOrder.ASC
                          ? t`Sorted ascending`
                          : t`Sorted descending`
                      }
                      aria-hidden={false}
                    />
                  )}
                </HStack>
              </Flex>
            </Th>
          );
        })}
      </Tr>
    </Thead>
  );
}
